import { c as _c } from "react/compiler-runtime";
import React, { Suspense, startTransition, useEffect, useRef, useState } from 'react';
const PDPDeferredSection = t0 => {
  const $ = _c(6);
  const {
    children,
    fallback: t1
  } = t0;
  const fallback = t1 === undefined ? null : t1;
  const [ready, setReady] = useState(false);
  const frameRef = useRef(null);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      frameRef.current = requestAnimationFrame(() => {
        frameRef.current = requestAnimationFrame(() => {
          startTransition(() => setReady(true));
        });
      });
      return () => cancelAnimationFrame(frameRef.current);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  if ($[2] !== children || $[3] !== fallback || $[4] !== ready) {
    t4 = ready ? <Suspense fallback={fallback}>{children}</Suspense> : fallback;
    $[2] = children;
    $[3] = fallback;
    $[4] = ready;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default PDPDeferredSection;